import NBTrpc from '@tencent/nb-trpc';
import Platform from './platform';

const URL = 'logservice/reportfrontendlog';
const baseURL = 'https://yz.html5.qq.com';

const defaultConfig = {
  version: '0.0.1',
  platform: Platform.name,
  biz: 'YZ',
};

export function setTrpcConfig(config = {}, logger) {
  Object.assign(defaultConfig, config);

  defaultConfig.dua = `DV=${config.version || '0.0.1'}&PL=${defaultConfig.platform}`;

  NBTrpc.setConfig(defaultConfig);

  logger.trpcBaseURL = defaultConfig.serverUrl ? defaultConfig.serverUrl : baseURL;

  window.NBTrpc = NBTrpc;
}

/**
 * 发送消息
 * @param {Array} dataArray 消息数组
 * @return {Object} Promise 对象
 */
export function sendLog(dataArray) {
  if (!dataArray || dataArray.length === 0) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    NBTrpc.newRequest(`${URL}`, {
      Logs: dataArray,
    }, {
      serverUrl: this.trpcBaseURL || baseURL,
      withCredentials: true,
    })
      .then((res) => {
        // 检查是否接口异常
        if (res && res.header) {
          const errorHeaders = ['fcgi-ret', 'trpc-ret'];
          let isFailed = false;
          for (const key in res.header) {
            if (errorHeaders.indexOf(key) > -1) {
              isFailed = true;
              break;
            }
          }

          if (isFailed) {
            this.store.save(dataArray);
            reject();
            return;
          }
        }

        resolve();
      })
      .catch((errTrpc) => {
        this.store.save(dataArray);
        reject(errTrpc);
      });
  });
}
